export default {
  // 页面标题
  title: 'AhaCreator',
  newCampaign: '新建营销计划',

  // AI代理
  aiAgent: {
    placeholder: '如有任何问题，请随时打断我提问',
  },

  // 模态框标题
  modalTitles: {
    paymentDetails: '付款详情',
  },

  // 按钮文本
  buttons: {
    saveDraft: '保存草稿',
    next: '下一步',
    update: '更新',
    release: '发布',
    signUpForMore: '免费注册，解锁更多',
    saveAndExit: '保存并退出',
  },

  // 帮助提示
  help: {
    whatHappensAfterPublish: '发布后会发生什么？',
    skipStepTooltip: '对当前计划信息很有把握？可跳过此步，直接进入下一步。',
  },

  // 关闭确认模态框
  closeModal: {
    title: '未保存的更改',
    description: '您有未保存的更改，确定要退出吗？',
    notSaved: '未保存',
  },

  // 消息提示
  messages: {
    rechargeFailed: '充值失败',
    rechargeSuccessful: '充值成功！余额已更新。',
  },

  // 错误消息
  errors: {
    getCampaignDetailFailed: '获取计划详情失败',
    bindOrgFailed: '组织绑定失败',
    networkError: '网络错误。请刷新页面后重试。',
  },

  // 产品类型
  productType: {
    webApp: 'Web 应用',
    mobileApp: '移动应用',
    desktopApp: '桌面应用',
    browserExtension: '浏览器插件',
    physicalProduct: '实体产品',
  },

  // 业务模式
  businessModel: {
    toBusiness: '面向企业',
    toCustomer: '面向消费者',
    b2b: 'B2B',
    b2c: 'B2C',
  },

  // 活动目标
  campaignObjective: {
    awareness: '品牌知名度',
    websiteTraffic: '网站流量',
    installs: '下载安装',
    leads: '客户留资',
    signUps: '用户注册',
    sales: '用户付费',
  },

  // 活动目标子类型
  campaignObjectiveSubType: {
    subscription: '订阅',
    payAsYouGo: '按需付费',
    oneTimePayment: '一次性付费',
  },

  // 目标表单标签
  targetForm: {
    installs: {
      title: '点击-安装转化率',
      desc: '可填写当前或目标转化率，用于预估活动结果。',
      tips: '行业参考：60%-80%。',
      message: '请输入点击-安装转化率',
    },
    signUps: {
      title: '点击-注册转化率',
      desc: '可填写当前或目标转化率，用于预估活动结果。',
      tips: '行业参考：20%-50%。',
      message: '请输入点击-注册转化率',
    },
    leads: {
      title: '点击-留资转化率',
      desc: '可填写当前或目标转化率，用于预估活动结果。',
      tips: '行业参考：1%-5%。',
      message: '请输入点击-留资转化率',
    },
  },

  // 目标选项
  targetOptions: {
    traffic: {
      title: '流量',
      desc: '把合适的受众引导至您的目标页，如网站、App、社媒主页等。将跟踪链接点击（PV）。',
    },
    leads: {
      title: '线索',
      desc: '为您的品牌收集销售线索，促使用户采取行动。',
    },
  },

  // 成功模态框
  successModal: {
    congratulations: '恭喜！计划已创建。审核通过后 24–48 小时内将收到达人的申请。',
    congratulationsColdEmail: '恭喜！计划已创建。',
    descriptionGuide: '同时可先了解 AhaCreator 的关键用法和使用技巧，帮助您最大化营销效果',
    descriptionColdEmail: '我们正在为您配置邮箱域名与账户。预热通常至少需要 7 天，完成后将开始发送邀请。',
    descriptionNormal: '您也可以先查看活动详情，或了解 AhaCreator 的关键用法以取得更好效果',
    viewCampaign: '查看营销计划',
    importantSeeNext: '重要：接下来会发生什么',
    checkHeadInstructions: '查看 AhaCreator 使用指南',
  },

  // 高级设置
  advancedSetting: {
    title: '高级设置',
  },

  // 设置页面
  settings: {
    title: '设置',
    save: '保存',
    cancel: '取消',
    saveSuccess: '保存成功！',
    placements: '投放位置',
    languages: '语言',
    locations: '地区',
    targetingSectionTitle: '投放设置',
    searchCountryOrRegionPlaceholder: '搜索国家/地区',
    pleaseSelectAtLeastOneLanguage: '请至少选择一种语言',
    influencerMarketingPostDate: '达人营销发布时间',
    affiliateMarketingContentPostDate: '分销内容发布时间',
    landingPageLink: '请提供用户点击后到达的页面链接',
    selectAll: '全选',
    pleaseSelectAtLeastOnePlatform: '请至少选择一种平台内容类型',
    pleaseSelectAtLeastOneRegion: '请至少选择一个地区',
    pleaseSelectPostDate: '请选择发布时间',
    flexiblePostTime: '弹性发布时间：达人在内容通过审核后即可发布。',
    fixedPostTime: '固定发布时间：达人需在指定时间窗口内发布内容。',
    selectCampaignStartDates: '建议至少提前 1 个月开始活动，以便达人有充足时间制作内容。',
    influencersRequiredToPost: '达人在申请通过后需于 7 天内发布内容',
    currentSelectionMayLimit: '当前选择可能限制达人的匹配范围。为获得更好结果，建议增加平台、语言或地区以扩大覆盖。',
    selectedPlatformsMayLimit: '所选平台可能限制活动触达。为提升表现，请考虑增加平台类型。',
    chooseSocialPlatforms: '选择达人的平台和内容形式',
    enterLanguageToShowAds: '选择您想要投放的受众语言。',
    chooseBroadAreaToShowAds: '选择更广的展示地区通常能带来更好结果。',
    specifyParticularDateWindow: '如需达人在特定时间段发布，请在此指定。',
    influencerPostDeadlineTitle: '达人发布截止时间',
    earliestPostDateLabel: '最早发布日期',
    latestPostDateLabel: '最晚发布日期',
    latestPostDateVerySoonTitle: '最晚发布日期过近',
    latestPostDateVerySoonDescription: '您的最晚发布日期为 {date}，仅剩 {days} 天。较短的准备周期会降低达人申请率并抬高报价，建议适当延后。',
    latestPostDatePassedTitle: '最晚发布日期已过期',
    latestPostDatePassedDescription: '您的最晚发布日期为 {date}，已过期。过期日期会让达人不确定活动是否仍在进行，从而拖累合作进度，请将日期延后。',
    earliestPostDateBeforeToday: '最早发布日期不能早于今天',
    latestPostDateAfterEarliest: '最晚发布日期不能早于最早发布日期',
    trackingLinkDescription: 'AhaCreator 会基于此链接为每位达人生成唯一追踪链接，以便统计点击与表现。（例如: 浏览量、点击量、CPM和CPC等）',
    influencerLink: {
      title: '您希望如何向达人提供链接',
      selectModeRequired: '请选择您希望如何向达人提供链接',
      autoLabel: '由 AhaCreator 自动生成唯一链接',
      autoDesc:
        'AhaCreator 将根据您的目标链接为每位达人生成唯一追踪链接，便于按达人统计表现（浏览量、点击量、CPM、CPC）。',
      manualLabel: '使用我自己的唯一链接',
      manualDesc:
        '确认合作后，您可在平台上为每位达人分配唯一链接。Aha 仅统计浏览量和 CPM。',
    },
    coldEmailSettings: '邮件',
    emailSenderName: '发件人名称',
    letAIAgentSetCPM: '让 Agent设定 CPM',
    letAIAgentSetCPMDesc: '由 Agent 为您设定 CPM，适用于没有 CPM 上限的品牌。',
    smartMode: '智能模式',
    setMaximumCPMManually: '手动设置最大 CPM',
    setMaximumCPMManuallyDesc: '手动设定 CPM 上限，适用于有严格 CPM 上限的品牌。',
    manualMode: '手动模式',
    letAIAgentNegotiatePrice: '让 Agent 协商价格',
    letAIAgentNegotiatePriceDesc: '由 Agent为您争取最优价格，适用于单个达人预算不设上限的品牌。',
    setPriceLimitsManually: '手动设置价格范围',
    setPriceLimitsManuallyDesc: '手动设定达人预算上限/下限，适用于预算严格受限的品牌。',
    highestBudgetPerInfluencer: '单个达人最高预算',
    lowestBudgetPerInfluencer: '单个达人最低预算',
    emailSenderTitle: '发件人头衔',
    emailToForwardConvertedLeads: '线索转交邮箱',
    pleaseEnterEmailSenderName: '请输入发件人名称',
    pleaseEnterEmailSenderTitle: '请输入发件人头衔',
    pleaseEnterEmailSenderForwardEmail: '请输入线索转交邮箱',
    pleaseEnterValidName: '请输入有效名称',
    pleaseEnterValidEmailAddress: '请输入有效邮箱地址',
    advancedInfluencerSettings: '高级达人设置',
    influencerFilterWarning: '请注意，应用达人筛选逻辑将限制您的达人供应。请谨慎设置。',
    influencerSettings: {
      performanceActivity: '表现与活跃度',
      minimumPredictedViews: '中位数播放范围',
      minimumPredictedViewsTooltip: 'AhaCreator 使用历史数据预测达人的浏览量。如果不设置，默认预测浏览量阈值为 YouTube: 400, TikTok: 1500, Twitter: 700, LinkedIn: 500, Instagram: 1500',
      predictedViewsRange: '浏览量范围',
      predictedViewsRangeNoMaxPlaceholder: '不设上限',
      predictedViewsRangeMaxMustBeGteMin: '最大值须大于或等于最小值',
      minimumFollowers: '最低粉丝数',
      followersRange: '粉丝数范围',
      postingFrequency: '发布频率',
      postingFrequencyRequired: '请输入发布频率',
      postsPerMonth: '次/月',
      lastPostTime: '最后发布时间',
      lastPostTimeRequired: '请输入最后发布时间',
      lastPostWithin: '最后发布在',
      lastPostTimeYoutubeWarningTitle: 'YouTube 条件过严',
      lastPostTimeYoutubeWarningDescription:
        'YouTube 达人发布频率较低，{days} 天的窗口可能会筛掉大部分匹配结果。建议设为 60 至 90 天。',
      price: '价格',
      maximumCpm: '最高 CPM',
      maximumPricePerInfluencer: '单个达人最高价格',
      minimumPricePerInfluencer: '单个达人最低价格',
      audience: '受众',
      audienceGender: '受众性别',
      genderRequired: '请选择性别',
      female: '女性',
      male: '男性',
      percentRequired: '请输入百分比',
      audienceGenderDesc: '选择达人受众中的主要性别及所需的最低百分比。',
      audienceAge: '受众年龄',
      ageRangeRequired: '请选择年龄范围',
      audienceAgeDesc: '选择一个或多个年龄范围及所需的最低受众百分比。',
      audienceLocation: '地区',
      audienceLocationPlaceholder: '选择国家',
      minLocationPercentage: '地区占比下限（%）',
      audienceLocationMore: '更多',
      audienceLocationLess: '收起',
      selectAll: '全选',
      recentActivity: '近期活跃',
      fineTuneAdvancedTargetingTitle: '高级设置',
      fineTunePerformanceFiltersTitle: '表现筛选',
      fineTunePerformanceFiltersTooltip:
        '开启过多表现类筛选会明显减少可匹配达人数量。除非某项指标对活动至关重要，建议保持关闭，交由 AhaCreator 基于完整达人分析进行优化。',
      fineTuneAudienceFiltersTitle: '受众筛选',
      fineTuneAudienceFiltersTooltip:
        '受众条件过严会显著减少可匹配达人。建议尽量放宽或留空，由 AhaCreator 结合完整达人分析寻找更合适的合作对象。',
      fineTuneMaximumCpmTooltip:
        '过严的 CPM 上限可能排除整体 ROI 仍然很高的优质达人。建议不设上限或设置较宽松的上限。',
      fineTuneMaximumPricePerInfluencerTooltip:
        'AhaCreator 支持还价功能，可与报价较高的匹配达人协商。适当提高上限有助于触达更多达人、拓展合作机会。',
      priceLimitSameAllPlatforms: '全平台统一',
      priceLimitCustomizePerPlatform: '按平台分别设置',
      cpmNoLimitPlaceholder: '不设上限',
      maximumPriceFieldPlaceholder: '不设上限',
      maximumPriceGlobalFieldPlaceholder: '不设单个达人最高价格',
      minimumPlaceholder: '最低值',
      noMinimumPlaceholder: '不设下限',
      above: '高于',
      engagementRatePlaceholder: '例如 4.5',
      engagementRateTooltipYoutube:
        '达人最近 20 条视频的中位互动率。每条视频的计算方式为：（点赞 + 评论）÷ 播放量。',
      engagementRateTooltipInstagram:
        '达人最近 20 条帖子的中位互动率。每条帖子的计算方式为：（点赞 + 评论）÷ 播放量。',
      engagementRateTooltipTiktok:
        '达人最近 20 条视频的中位互动率。每条视频的计算方式为：（点赞 + 评论 + 分享 + 收藏）÷ 播放量。',
      engagementRateTooltipTwitter:
        '达人最近 20 条推文的中位互动率。每条推文的计算方式为：（点赞 + 评论 + 分享 + 收藏）÷ 播放量。',
      engagementRateTooltipLinkedIn:
        '达人最近 20 条帖子的中位互动率。每条帖子的计算方式为：（点赞 + 评论）÷ 播放量。',
      minGenderPercentage: '性别占比下限（%）',
      audienceAgeRange: '年龄段',
      minAgePercentage: '年龄占比下限（%）',
      audienceGenderOptionAny: '不限',
      audienceGenderOptionFemaleDominant: '女性为主',
      audienceGenderOptionMaleDominant: '男性为主',
      fineTuneInfluencerAttributesTitle: '达人属性',
      fineTuneInfluencerAttributesTooltip:
        '开启过多达人属性筛选会明显减少可匹配达人数量。除非某项指标对活动至关重要，建议保持关闭，交由 AhaCreator 基于完整达人分析进行优化。',
      fineTuneInfluencerGenderTitle: '达人性别',
      fineTuneInfluencerGenderOptionMale: '男性',
      fineTuneInfluencerGenderOptionFemale: '女性',
      fineTuneInfluencerAgeTitle: '达人年龄',
      fineTuneInfluencerAgeOptionUnder18: '18 岁以下',
      fineTuneInfluencerAgeOption18To34: '18-34',
      fineTuneInfluencerAgeOption35To64: '35-64',
      fineTuneInfluencerAgeOptionAbove64: '64 岁以上',
      fineTuneInfluencerEthnicityTitle: '达人族裔',
      fineTuneInfluencerEthnicityOptionWhite: '白人',
      fineTuneInfluencerEthnicityOptionBlack: '黑人',
      fineTuneInfluencerEthnicityOptionAsian: '亚裔',
      fineTuneInfluencerEthnicityOptionHispanicLatino: '西班牙裔 / 拉丁裔',
      fineTuneInfluencerEthnicityOptionMiddleEastern: '中东裔',
      fineTuneInfluencerEthnicityOptionOther: '其他',
      fineTuneOnCameraTitle: '出镜形式',
      fineTuneOnCameraOptionOnCamera: '真人出镜',
      fineTuneOnCameraOptionAvatarVirtual: '虚拟形象',
      fineTuneOnCameraOptionFaceless: '无露脸',
      fineTuneVoiceoverTitle: '口播',
      fineTuneVoiceoverOptionMustHave: '必须有口播',
      fineTuneVoiceoverOptionNoPreference: '无偏好',
      fineTuneTikTokShopAffiliateTitle: 'TikTok Shop 联盟',
      fineTuneTikTokShopAffiliateOptionSupports: '支持联盟带货',
      fineTuneTikTokShopAffiliateOptionNoPreference: '无偏好',
    },
    emailSenderNamePlaceholder: '该名称将作为冷邮件的发件人名称',
    emailSenderTitlePlaceholder: '该头衔将与发件人名称一同显示',
    emailForwardPlaceholder: '我们会将优质的转化线索转发至该邮箱',
    developedEnglishSpeakingMarkets: '英语成熟市场',
    developedMarkets: '成熟市场',
    developedAndEmergingMarkets: '成熟 + 新兴市场',
    locationBagsDescription: '点击上方分组可快速添加预设的国家/地区。',
    productExplainerVideo: '产品讲解视频',
    productExplainerVideoDesc: '上传一个介绍您产品/服务的 YouTube 精彩视频，便于达人快速理解您的产品优势，提高接单率。',
    customBrandGuidelines: '自定义合作要求',
    customBrandGuidelinesDesc: '除',
    platformRequirements: '平台规范',
    customBrandGuidelinesDescEnd: '如您已有完整的 brief，也可在此一并补充。',
    referenceInfluencers: '参考达人',
    referenceInfluencersDesc: '上传您喜欢的达人列表，AhaCreator 将为您的活动寻找相似达人。',
    downloadTemplate: '下载模板',
    blocklist: '屏蔽名单',
    blocklistDesc: '上传您不希望合作的达人名单。',
    brandAssets: '品牌素材',
    brandAssetsDesc: '通过 Google Drive 或其他网盘上传希望与达人共享的品牌素材。请遵循',
    brandAssetsUploadRequirements: '品牌素材上传要求',
    brandAssetsDescEnd: '以助于达人成品达到更佳效果。',
    add: '添加',
    upload: '上传',
    pleaseInputValidYoutubeLink: '请输入有效的 YouTube 链接！',
    pleaseInputValidLink: '请输入有效链接！',
    pleaseEnterBrandAssetsLink: '请输入品牌素材链接…',
    mustUsePlaceholder: '例如：必须展示 xxx 功能。',
    theFileDoesNotContain: '文件中未包含任何达人资料',
    notice: '提示',
    confirmToAdd: '确认添加',
    notNow: '暂不',
    kindReminder: '温馨提醒',
    youHaveSelectedCountriesOrLanguages: '您已选择以下国家/地区或语言：',
    doYouWantToAddRecommended: '是否同时添加以下推荐的语言或国家/地区？',
    pricingPlan: '计费方案',
    freelancingModel: '外包模式',
    payAsYouGo: '按需付费',
    commissionDescription: '每次与达人合作收取 5% 的服务佣金。',
    employmentModel: '雇佣模式',
    yearly: '年付',
    twoMonthsFree: '每年赠送 2 个月',
    noCommissionsDescription: '不收取佣金，每月按达人营销预算的 7.9% 计费。节省',
    vsPayAsYouGo: '相较按需付费。',
    affiliateMarketing: '分销营销',
    affiliateRecruitmentBudget: '分销招募预算',
    affiliateRecruitmentBudgetDesc: '通过 AhaCreator 招募分销达人的总预算。仅在您确认达人加入时收取；后续佣金在其产生销售后另行结算。常见成本从几美元到 100 美元不等。',
    pleaseSelectBudgetForAffiliate: '请选择预算',
    affiliateCommissionRate: '分销佣金比例',
    pleaseEnterAffiliateCommissionRate: '请输入佣金比例',
    industryBenchmarkCommission: '行业参考：10%–80%',
    averageOrderValue: '平均客单价（AOV）',
    pleaseEnterAverageOrderValue: '请输入平均客单价',
    industryBenchmarkOrder: '行业参考：B2B 50–500 USD，B2C 10–100 USD',
    coldEmail: '冷邮件',
    coldEmailDescription: '发布活动时需支付 30 USD 以覆盖域名搭建、邮箱预热、外联等基础成本。',
    budgetToAcquireConvertedLeads: '获取转化线索预算',
    pleaseSelectBudgetForLeads: '请选择预算',
    positiveResponseRateOutOfSentEmails: '邮件正向回复率',
    pleaseEnterPositiveReplyRate: '请输入正向回复率',
    industryBenchmarkResponseRate: '行业参考：B2B 3%–10%，B2C 1%–5%',
    positiveResponseToPurchaseRate: '正向回复-下单转化率',
    pleaseEnterConversionRate: '请输入转化率',
    industryBenchmarkConversionRate: '行业参考：B2B 8%–25%，B2C 3%–15%',
    averageCustomerLifetimeValue: '平均客户生命周期价值（LTV）',
    pleaseEnterAverageCustomerLifetimeValue: '请输入 LTV',
    // 其他设置相关文本
    placementsInfoModal: {
      title: '平台内容形式与使用场景',
      platform: '平台',
      contentFormat: '内容形式',
      keyFeatures: '使用场景',
      youtubeDedicated: '专题视频',
      youtubeIntegrated: '插片视频',
      instagramReel: 'Reels',
      instagramCarouselPost: '轮播贴',
      tiktokVideo: '视频',
      Posts: '帖子',
      youtubeDedicatedDesc: '全片围绕品牌展开，适用于新品发布、深度评测及品牌故事呈现。',
      youtubeIntegratedDesc: '品牌片段，占达人视频至少 30% 的内容 — 经济实惠的选项，用于自然但实质性的曝光。',
      instagramReelDesc: '短视频，强大算法触及 — 最佳用于产品发布、病毒趋势和快速品牌曝光。',
      instagramCarouselPostDesc: '最多 10 张幻灯片，混合图像和视频。最佳用于故事叙述、产品演示、比较和教程。',
      tiktokVideoDesc: '垂直短视频混合到用户 feed 中 — 强大的 mass reach、创意故事讲述和年轻受众。',
      linkedinImagePostDesc: '专业图片帖子，带有文本、图像或视频 — 最佳用于 B2B 品牌、招聘和信誉建立。',
      linkedinVideoPostDesc: '达人领衔视频，分享使用案例、专家意见或 testimonials — 强有力的信任建立和决策者之间的参与。',
      linkedinImagePost: 'LinkedIn 图片帖子',
      linkedinVideoPost: 'LinkedIn 视频帖子',
      twitterPostDesc: '灵活帖子，带有文本、图像或视频 — 最佳用于时事关注、品牌声音和病毒传播。',
      linkedinPostDesc: 'LinkedIn 视频或轮播贴，展示产品价值、见解、合作和真实使用案例 — 最佳用于构建专业信誉、信任和决策者之间的参与。',
    },
    twitterPostTooltip: "X 可能包含更多互动 Pod。请仔细审核账户并确认公平价格后再进行合作。",
    languageMissPanel: {
      title: '根据您的目标地区，您可能需要添加这些语言：',
      addAll: '添加全部',
    },
    onlyCsvFiles: '仅支持 .csv 文件',
    desiredInfluencerProfiles: '期望达人画像',
    desiredInfluencerProfilesDesc: '期望达人画像描述了您希望合作的达人类型，以便 AhaCreator 能够自动匹配最符合您需求的达人。例如：AI Tools Daily — 擅长解读和介绍新 AI 工具的达人，用清晰、实用的方式分享使用经验。',
    pleaseInputMustDo: '请输入重要事项',
    matchingAccuracy: {
      title: '匹配准确度',
      focusMode: {
        label: '聚焦模式',
        desc: '专注于高度匹配的达人，提升匹配准确度。预期成本更高，活动周期更长。',
      },
      scaleMode: {
        label: '扩展模式',
        desc: '在保持良好相关性的同时扩大达人池——提升效率、降低成本并缩短活动周期。',
      },
      maxScaleMode: {
        label: '最大扩展模式',
        desc: '通过扩大相关性边界最大化触达——大幅降低成本并加速活动周期。',
      },
    },
  },

  // 业务信息
  businessInformation: {
    title: '产品信息',
    companyName: '公司名称',
    website: '官网',
    industry: '行业',
    coreSellingPoints: '核心卖点',
    coreAudiences: '核心产品受众',
    advancedSettings: '高级设置',
    gender: '性别',
    age: '年龄',
    interest: '兴趣',
    aiGeneratedDescription: '以下内容由 AhaCreator 基于品牌分析生成，请按需校对与完善！',
    basicInformation: '基础信息',
    businessLogo: '品牌 Logo',
    logoFormatNote: '仅支持上传 SVG 格式 Logo。',
    upload: '上传',
    businessName: '品牌/企业名称',
    productServiceType: '产品 / 服务类型',
    benchmarkBrands: '对标品牌',
    importantMatters: '重要事项',
    importantMattersDescription: '请在下面填写需要达人特别注意的任何信息，例如：产品使用禁令、需要提及的要点、@tag的帐户等。',
    importantMattersPlaceholder: '请输入达人需要注意的重要事项',
    businessIntroduction: '品牌/业务介绍',
    pleaseEnterBusinessName: '请输入品牌/企业名称',
    pleaseEnterBenchmarkBrands: '请输入对标品牌',
    benchmarkBrandsDescription: '我们会使用您的对标品牌来匹配与这些品牌合作过或触达相似受众的达人。将最相似的品牌放在顶部以提高匹配准确度。',
    campaignName: '营销计划名称',
    pleaseEnterCampaignName: '请输入本次营销计划名称',
    pleaseSelectGender: '请选择性别',
    pleaseSelectAge: '请选择年龄段',
    pleaseEnterInterests: '请输入受众兴趣点，使用英文逗号","分隔',
    pleaseFillInInfluencerAccessCredits: '请填写达人访问权限和积分信息',
    endorsementPlaceholder: '例如：融资、主要合作伙伴、用户增长、收入...',
    endorsementPlaceholderDesc: '奖项、媒体报道、产品认证、融资、用户增长、过往合作——任何能让达人兴奋并相信您安全可靠的内容。',
    brandHighlightsEndorsements: '品牌亮点 & 背书',
    pleaseEnterBusinessIntroduction: '请输入品牌/业务介绍',
    forInfluencerMatching: {
      label: '用于达人匹配',
      tooltip: '此信息有助于 AhaCreator 找到受众和内容与您的营销计划最匹配的达人。',
    },
  },

  // 选择目标
  selectObjective: {
    title: '选择营销目标',
    awareness: '品牌知名度',
    traffic: '流量',
    leads: '线索',
    installs: '安装',
    signUps: '注册',
    sales: '销售',
    // 其他目标相关文本
  },

  // 平台内容标签
  platformContentLabel: {
    or: ' 或 ',
    youtubeDedicated: 'YouTube 专题视频',
    youtubeIntegrated: 'YouTube 插片视频',
    tiktokVideo: 'TikTok 视频',
    instagramReel: 'Instagram Reels',
    instagramCarouselPost: 'Instagram 轮播贴',
    twitterPost: 'Twitter / X 帖子',
    linkedinPost: 'LinkedIn 帖子',
    linkedinImagePost: 'LinkedIn 图片帖子',
    linkedinVideoPost: 'LinkedIn 视频帖子',
  },

  // 预算出价
  budgetBidding: {
    title: '预算与出价',
    dailyBudget: '日预算',
    totalBudget: '总预算',
    budgetPerInfluencer: '单个达人预算',
    budgetLimitWarning: '请为每位达人设置合理的预算上限。过低或过高都可能影响供给。如不确定，建议选择「智能模式」。',
    chooseBudgetLimit: '选择预算上限',
    maximumCpm: '最大 CPM',
    influencerMarketing: '达人营销',
    totalInfluencerPayment: '达人总费用',
    totalBudgetDescription: '设置您的总预算——您可以随时在活动发布后调整预算。仅在内容交付后才会支付，活动发布后可随时调整预算。',
    pleaseSelectBudgetForInfluencer: '请选择预算',
    name: '姓名',
    followers: '粉丝数',
    estViewsPerPost: '预计播放/条',
    matchReason: '匹配理由',
    profile: '资料',
    view: '查看',
    sampleInfluencersTitle: '可能合作的示例达人',
    sampleInfluencersDesc: '基于您的活动信息，我们预先匹配了部分示例达人，便于评估受众契合度。如不理想，可随时调整活动输入。',
    notSeeingIdealMatches: '没有看到理想匹配？',
    adjustYourInputs: '试试调整筛选条件',
    currentPlan: '当前方案',
    perMonth: '/ 月',
    influencerFee: '达人费用',
    verifyYourAuthorization: '验证授权',
    reviewCampaignTerms: '确认营销计划条款',
    campaignTermsDescription: '请阅读并确认适用于本次营销计划的条款。为确保合作授权书具备法律效力，请填写您的法定全名以完成正式验证。',
    terms: '条款',
    productSampleTerm: '我已阅读并知悉：AhaCreator 通过标准化交付节点、自动提醒机制和达人评级体系等措施降低违约风险。如达人收到产品样品后仍失联，AhaCreator 将尽努力联系并跟进，但无法保证样品退回，也无法向品牌方赔偿其价值。',
    cancellationTerm: '我知悉，如因品牌方自身原因取消合作，例如品牌方决定停止推广该产品，则达人在上传脚本或内容初稿后，有权获得订单金额的 30%。如果达人已提交最终发布链接，而品牌方在没有合理且明确说明理由的情况下拒绝最终确认，则达人有权获得订单金额的 50%。',
    pleaseAgreeToTerms: '请同意相关条款',
    pleaseProvideLegalName: '请输入您的法定全名',
    cancel: '取消',
    authorizationDescription: '为确保与 AhaCreator 的授权文件具备法律效力，请填写您的法定全名以完成验证。未通过授权将无法发布活动。',
    fullLegalName: '法定全名',
    fullLegalNamePlaceholder: '例如：John Doe',
    // Influencer application preview related
    influencerApplicationPreview: '达人申请预览',
    actualValuesMayFluctuate: '实际价值可能会因市场动态、达人供应和相关条件等因素而波动。上面显示的达人仅供预览和参考；一旦活动发布，将进行最终匹配。',
    // Subscription related
    monthlySubscriptionCancellationRate: '月度订阅流失率',
    pleaseEnterMonthlySubscriptionCancellationRate: '请输入月度订阅流失率',
    industryBenchmarkSubscription: '行业参考：B2B 1%–3%，B2C 5%–10%',
    clickToPurchaseRate: '点击-购买转化率',
    pleaseEnterClickToPurchaseRate: '请输入点击-购买转化率',
    industryBenchmarkClickToPurchase: '行业参考：1%–5%。',
    // Pay-as-you-go related
    clickToPayConversionRate: '点击-支付转化率',
    pleaseEnterClickToPayConversionRate: '请输入点击-支付转化率',
    payingUserARPU: '付费用户 ARPU',
    pleaseEnterPayingUserARPU: '请输入付费用户 ARPU',
    payingUserARPUDescription: '每位付费用户带来的平均收入。',
    // Table column titles
    estimatedPrice: '预估价格',
    predictedCPM: '预测 CPM',
    predictedViews: '预测播放量',
    predictedCPC: '预测 CPC',
    predictedClicks: '预测点击',
    // Landing page URL related
    conversionTrackingAlert: '请确保承接页面已配置转化追踪。转化追踪可帮助评估点击带来的有效行为，并据此优化投放。了解更多：',
    viewHeadDevelopmentDoc: '查看 AhaCreator 开发文档',
    pleaseEnterValidLink: '请输入有效链接',
    landingPagePlaceholder: '用户在观看达人内容后将访问的链接',
    back: '上一步',
    continue: '继续',
    partnershipAuthorization: '合作授权',
    authorizationText1: '确认后，您即',
    authorizationText2: '（由 Ahalab.ai Inc. 运营）代表您管理本次营销计划。',
    authorizationDescription1: '该授权文件将在达人接收任务时显示，提升合作可信度，减少不必要的来回沟通。',
    authorizationDescription2: '多数达人无需进一步确认，',
    authorizationDescription2Highlight: '但也可能有少数达人会直接与您或团队核实。',
    authorizationDescription2End: '您可选择回复或忽略；我们的支持团队会负责后续跟进，确保流程顺畅。',
    reminder: '提醒',
    iConfirmAuthorization: '我确认授权',
    workEmailCheckTitle: '快速确认：请确认您代表该品牌',
    sensitiveIndustryNotice: '我们检测到该活动涉及敏感行业。为核验品牌合法性，请上传支持性文件（如营业执照等）。',
    workEmailCheckDescription: '您的工作邮箱与活动网站域名不一致，因此我们需要快速确认您已获授权代表该品牌投放活动。这有助于让达人确认他们正与正确的团队合作。任何能证明关联关系的材料都可以，例如：',
    workEmailProof1: '名片或邮件签名',
    workEmailProof2: '品牌授权函',
    workEmailProof3: '任意协作工具中的团队工作区截图（如 Slack、Teams、Lark）',
    upload: '上传',
    modalBack: '上一步',
    modalContinue: '继续',
    ifYouNeedAssistance: '如需帮助，欢迎',
    contactUs: '联系我们。',
    fileSizeExceedError: '文件大小不可超过 10MB！',
    failedToUploadLogo: 'Logo 上传失败',
    setCpmCap: '设置 CPM 上限',
  },

  // 预览匹配
  previewSampleMatches: {
    title: '示例匹配预览',
    saveSuccess: '保存成功！',
    feedbackTitle: '',
    feedbackDescriptionLoading: '您可以调整匹配准确度、品牌介绍、核心卖点或核心受众，以进一步提高匹配质量。',
    feedbackDescriptionFocusMode: '您正在查看在聚焦模式下生成的达人样本。如果结果不符合您的期望，请尝试调整设置，如匹配准确度模式、品牌介绍、核心受众或核心卖点，以进一步提高匹配质量。',
    feedbackDescriptionScaleMode: '您正在查看在扩展模式下生成的达人样本。如果结果不符合您的期望，请尝试调整设置，如匹配准确度模式、品牌介绍、核心受众或核心卖点，以进一步提高匹配质量。',
    feedbackDescriptionMaxScaleMode: '您正在查看在最大扩展模式下生成的达人样本。如果结果不符合您的期望，请尝试调整设置，如匹配准确度模式、品牌介绍、核心受众或核心卖点，以进一步提高匹配质量。',
    notGettingRightMatches: '没有得到理想的匹配？',
    highNotMatchRateMessage: '超过 40% 的达人被标记为“不匹配”。这表明您的活动信息中某些部分，如<b>匹配准确度、品牌介绍、核心卖点或核心受众</b>，可能需要 refinement。\n您想让 AhaCreator 自动优化这些部分吗？您的手动编辑将保持不变。',
    moreThan40Percent: '超过 40% 的达人被标记为',
    notAMatchPeriod: '不匹配。',
    thisUsuallyMeansInfo: '这通常意味着您的活动信息',
    likeAudienceCore: '（如品牌介绍、目标受众、核心卖点或匹配模式等）',
    mayNeedFineTuned: '可能需要微调以提升准确度。现在要检查并优化吗？',
    continueAnyway: '仍然继续',
    editCampaignInfoManually: '手动编辑活动信息',
    optimizeWithAI: '使用 AI 优化',
    matchReason: '匹配理由',
    match: '匹配',
    emptyMessage: '我们正在准备样本匹配以微调您的结果。此过程大约需要 2 分钟。',
    emptyMessage2: '初步测试匹配可在进行完整的达人匹配之前验证方向是否正确。',
    emptyMessageTips: '这是一个测试匹配，不是最终匹配结果。',
    endCard: {
      description: '您的初始匹配看起来很棒！基于您的反馈，我们将继续推进到正式匹配阶段，届时将为您匹配最符合目标受众的达人。',
      return: '更新您的反馈',
      notMatchDesc: '为了提高达人匹配的质量和相关性，我们建议调整您的活动信息。您可以让我们的AI助手立即优化您的广告系列，或',
      notMatchDescLink: '联系我们寻求帮助。',
      next: '下一步',
      expandWithAISuggestions: '使用 AI 优化',
      adjustMatchingAccuracyMode: '调整匹配准确度模式'
    },
    notAMatch: '不匹配',
    emptyMessageTime: '2分钟',
    timeSecond: '秒',
    timeMinute: '分钟',
    timeMinutes: '分钟',
  },

  // 创建估算面板
  createEstimatePanel: {
    estimatedCampaignResults: '营销结果预测',
    affiliateMarketingResultsEstimation: '分销营销结果预测',
    coldEmailResultsEstimation: '邮件营销结果预测',
    views: '播放量',
    cpm: 'CPM',
    clicks: '点击量',
    cpc: 'CPC',
    costPerInstallRange: '单次安装成本范围',
    installRange: '安装量范围',
    costPerLeadRange: '单条线索成本范围',
    leadRange: '线索量范围',
    costPerSignUpRange: '单次注册成本范围',
    signUpRange: '注册量范围',
    roiRange: 'ROI 范围',
    salesRange: '销售额范围',
    arpuCacRange: 'ARPU/CAC 范围',
    aovCacRange: 'AOV/CAC 范围',
    cpmAcrossDifferentPlatforms: '各平台 CPM 对比',
    numberOfAffiliates: '分销达人数量',
    noteSalesEstimates: '说明：销售额估算基于 1.5%–4.5% 的点击-购买转化行业参考。',
    potentialConvertedLeads: '潜在转化线索',
    potentialCustomers: '潜在客户数',
    potentialLifetimeRevenue: '潜在生命周期收入',
    roi: 'ROI',
  },

  // 受众
  audiences: {
    title: '受众',
    // 其他受众相关文本
  },

  // 创意
  creatives: {
    title: '创意',
    // 其他创意相关文本
  },

  // 开发策略
  developStrategy: {
    title: '开发策略',
    // 其他策略相关文本
  },

  // 增长策略
  growthStrategy: {
    title: '增长策略',
    // 其他增长相关文本
  },

  // 活动创意
  campaignIdeas: {
    title: '营销创意',
    // 其他创意相关文本
  },

  // 活动步骤
  campaignSteps: {
    setupCampaign: '设置营销计划',
    basicInformation: '基础信息',
    settings: '设置',
    previewSampleMatches: '示例匹配预览',
    budgetAndResults: '预算与结果',
    enterOtherInformation: '填写其他信息',
    reviewSummary: '审核摘要',
    collapse: '收起',
  },

  // 选择交付模式
  selectDeliveryMode: {
    title: '选择交付模式',
    serviceModel: '服务模式',
    contactUsMessage: '发布前，欢迎联系我们，免费获取一堂达人营销速成课。',
    serviceModelComparison: '服务模式对比',
    // 其他交付模式相关文本
  },

  // 产品分析
  productAnalysis: {
    title: '产品分析',
    // 其他产品分析相关文本
  },

  // 审核摘要
  reviewSummary: {
    title: '审核摘要',
    // 其他审核相关文本
  },

  // 添加Stripe
  addStripe: {
    title: '添加 Stripe',
    // 其他Stripe相关文本
  },

  // 落地页URL
  landingPageUrl: {
    title: '落地页链接',
    // 其他落地页相关文本
  },

  // 其他信息
  otherInformation: {
    title: '其他信息',
    // 其他信息相关文本
  },

  // 进度时间线
  progressTimeline: {
    title: '进度阶段',
    editCampaign: '编辑计划',
    headThinking: 'AhaCreator 正在思考…',
    headFinished: 'AhaCreator 思考完成。',
    noMoreInfluencers: '当前没有更多与您活动匹配度高的达人。如需寻找更多达人，建议调整活动详情；我会基于最新信息继续识别并联络合适达人。',
    // 其他进度相关文本
  },

  // 网站表单
  websiteForm: {
    title: '网站表单',
    welcomeMessage: 'Hi {firstName}！很开心能跟你一起设计真正有效的营销策略，落地一场专家级的 Campaign。把你的 URL 贴进来，我会为你提供一份基础的品牌分析，并在此基础上和你一起进行细化调整。这些信息，也能让我更精准的找到适合你品牌的达人哦～',
    welcomeMessageNoName: 'Hi！很开心能跟你一起设计真正有效的营销策略，落地一场专家级的 Campaign。把你的 URL 贴进来，我会为你提供一份基础的品牌分析，并在此基础上和你一起进行细化调整。这些信息，也能让我更精准的找到适合你品牌的达人哦～',
    pleaseEnterWebsite: '请输入网站地址',
    pleaseEnterValidWebsite: '请输入有效的网站地址',
    websitePlaceholder: '输入产品/应用官网、Amazon 链接、Shopify 链接等',
    generate: '生成',
    errorOccurred: '发生错误，请稍后重试。',
    // 其他网站表单相关文本
  },
  websiteLoading: {
    settingUpCampaign: '设置活动',
    readStory: '查看案例',
  },

  // V4 创建活动 — Brief 步骤
  v4Brief: {
    back: '返回',
    analyzingTitle: '正在分析您的需求并配置活动，大约需要 2 分钟。',
    headline:
      '把你想推广的产品链接或 brief 贴进来，我帮你自动生成达人策略和制作要求，供你审核调整哦',
    textareaPlaceholder:
      '请说明推广内容：粘贴商品链接、描述活动，或上传简报。',
    uploadBrief: '上传活动 brief',
    start: '开始',
    inaccessibleLinkTitle: '无法访问此链接',
    inaccessibleLinkHint: '请将链接设为“公开可查看”，然后重新粘贴',
    manualSetup: '还没有产品链接或 brief? 也可以一步步手动设置～',
    /** 微调策略步骤 — 内联 Brief 编辑（上传条、保存后策略弹窗） */
    fineTuneCardTitle: '推广的产品链接或选人要求',
    dragUploadLeading: '点击上传或拖拽到此处',
    dragUploadSeparator: '-',
    dragUploadFormats: 'PDF、DOCX、PPT',
    afterBriefSaveStrategyModalTitle: '产品链接或选人要求已更新，是否同步更新达人策略？',
    afterBriefSaveStrategyModalBody:
      '我们将根据新的输入重新评估策略，包括达人画像、设置（平台、地区等）及高级设置。',
    keepCurrentStrategy: '保留当前策略',
    updateStrategy: '更新策略',
    missingCampaignId: '缺少活动 ID',
    saveFailed: '保存失败',
    uploadFileFailed: '文件上传失败',
  },

  /** V4 — 设置内容指引（达人简报步骤） */
  v4SetContentGuidelines: {
    /** BriefInfluencer — 可折叠的达人简报编辑区 */
    editorCardTitle: '粘贴达人内容制作brief 文档，我们将为您结构化整理',
    headline: '粘贴达人内容制作 brief，我们将为您结构化整理。',
    textareaPlaceholder:
      '可粘贴 Google 文档、Notion、飞书等内容制作 brief，或上传文件。',
    uploadBrief: '上传文件',
    start: '开始',
    inaccessibleLinkTitle: '无法访问此链接',
    inaccessibleLinkHint: '请将链接设为“公开可查看”，然后重新粘贴：',
    manualSetup: '没有内容制作 brief？手动设置',
    back: '返回',
  },

  /** V4 — Brief 达人步骤（页面框架） */
  v4BriefInfluencer: {
    analyzingTitle: '正在分析您的达人内容制作 brief并结构化整理，大约需要 40 秒。',
    warmBannerMessage:
      '受邀达人会在 AhaCreator 达人端看到下方所有内容，包括你上传的文件。这能帮助他们理解你的活动、产品和内容要求。',
    back: '返回',
    setBudget: '下一步',
  },

  /** V4 — Brief 达人流程 — 活动信息 */
  v4BriefInfluencerCampaignInfo: {
    campaignInformationSectionTitle: '活动信息',
    deliveryRequirementSectionTitle: '交付要求',
    productLogoLabel: '产品 Logo',
    productLogoRequired: '请上传产品 Logo',
    brandNameLabel: '品牌名称',
    brandNamePlaceholder: '请输入品牌名称',
    brandNameRequired: '请输入品牌名称',
    productNameLabel: '产品名称',
    productNamePlaceholder: '请输入产品名称',
    productNameRequired: '请输入产品名称',
    productTypeLabel: '产品类型',
    productTypeRequired: '请选择产品类型',
    productLinkLabel: '产品链接',
    productLinkPlaceholder: 'www.example.com',
    productLinkRequired: '请输入产品链接',
    productLinkInvalid: '请输入有效的产品链接',
    productIntroductionLabel: '产品介绍',
    productIntroductionRequired: '请输入产品介绍',
    uniqueSellingPointsFeaturesLabel: '独特卖点与功能',
    coreFeatureRequired: '请输入独特卖点与功能',
    coreFeaturePlaceholder:
      '更智能的推理——首款能理解设计师意图、而非仅限关键词的 AI 图像模型；可将数据表转为图表，处理空间逻辑、隐喻与否定。精准的局部编辑——在画布上圈选任意区域即可编辑，无需重新生成整张图像。',
    campaignBackgroundLabel: '活动背景 / 目标（选填）',
    campaignBackgroundPlaceholder:
      '目标：将 Seedream 5.0 Lite 定位为全球首款最智能的 AI 图像模型，在 Dreamina 上开启 AI 原生创意的新阶段。背景：Dreamina 的 Seedream 5.0 Lite 已作为全球首款正式上线，是 AI 图像生成的重要里程碑。我们希望与关注 AI 工具、创作流程与效率的达人合作，展示「史上发布的最智能图像模型」在实践中究竟意味着什么。当前 AI 图像工具多停留在生成字面意义上「好看」的结果；Seedream 5.0 Lite 是首个具备推理能力的模型——可将数据表转为图表、理解空间逻辑与隐喻，并支持精确的局部编辑。我们希望达人能直观感受到这种差异，而不只是罗列功能点。',
    campaignBackgroundHint:
      '达人了解您的目标后，往往能做出更贴切的内容。几句话即可。',
    brandHighlightsEndorsementsLabel:
      '为什么达人应该信任您（文案会展示在邀约邮件，建议填写）',
    endorsementUploadButton: '上传图片或文件',
    endorsementLinkWarning:
      '邀请中的链接会触发垃圾邮件过滤器。请从文本中删除此链接：',
    endorsementMaxLength:
      '该文字内容展示在达人邀约邮件中。邀约邮件越简洁，可读性却强，达人越愿意回复。请精简至 300 个字符以内。',
    removeEndorsementFile: '移除文件',
    otherSettingsTitle: '其他设置',
    otherSettingsOptionalBadge: '2 项选填',
    productTutorialWalkthroughLabel: '产品教程 / 演示（选填）',
    brandAssetsOptionalLabel: '品牌素材（选填）',
    brandAssetsShareHint:
      '通过 Google Drive 或其他链接上传希望与达人分享的品牌素材。',
  },

  /** V4 — Brief 达人 — 由 AhaCreator 交付给达人的简报字段 */
  v4BriefInfluencerAhaCreatorBrief: {
    coreMessageLabel: '希望达人传达的核心信息（选填）',
    creativeConceptLabel: '创意概念（选填）',
    referenceVideosLabel: '其他达人参考视频（选填，建议填写）',
    referenceVideosPlaceholder: '逐行粘贴视频链接',
    creativeConceptTips: {
      viewExample: '查看示例',
      focusTitle: '聚焦点',
      focusContent:
        '呈现「告别手动追单」——将过去需要 10 人运营团队完成的工作，浓缩为一名营销人员的一次决策。',
      hookReferenceTitle: '开场钩子参考',
      hookReferenceContent:
        '「我以前每周要给 500 位达人发邮件。今天我只做了一次决策就下班了。」（备选：「当我的老营销团队还在站会时，AhaCreator 已经筛选出 80 位达人、完成触达，并标记了 3 个风险画像。」）',
      visualReferenceTitle: '画面参考：',
      reference1Label: '参考 1：',
      reference1Content:
        '分屏：左侧「昨天的营销运营」——10 人在 Slack 争论、满屏表格、深夜催稿、堆积未回复的达人消息。右侧「AhaCreator Agent」——一人、一次审批点击，仪表盘展示 AI 自动执行触达 / 时间线管理 / 内容审核。',
      reference2Label: '参考 2：',
      reference2Content:
        '分屏：左侧一行 Brief——「帮我在东南亚找 50 位懂 AI、生活方式类、受众真实且调性契合的达人。」右侧实时仪表盘：AI 构建受众画像 → 扫描 500 万+ 数据库 → 呈现 80 位匹配达人，每位附带说明匹配理由的标签。',
      keyStatementTitle: '核心表述',
      keyStatementContent:
        '你的新角色：不是执行者，而是决策者。AhaCreator 负责运营执行；你的判断力是 AI 无法自动化的部分。',
      voFocusTitle: '旁白重点',
      voFocusContent:
        '强调 AhaCreator 不是「加快你的工作流」，而是「彻底拿掉运营执行层」。AI 端到端跑通全链路（发现 → 触达 → 时间线 → 审核 → 交付），让营销人夺回被重复执行吞噬的时间，重新聚焦只有人才能做的事：战略与判断。收尾落在：「8 万+ 认证达人。500 万+ 数据库。一个 Agent。你的判断。」',
    },
  },

  /** V4 — Brief 达人 — 达人如何接收简报 */
  v4BriefInfluencerReceiveBriefType: {
    questionLabel: '达人应如何收到内容制作 brief？',
    requiredMessage: '请选择达人接收简报的方式',
    ownBriefTitle: '使用自有 brief 文档',
    ownBriefDescription:
      '上传已有文档，可为不同达人群体提供不同版本（如科技向、头部达人等）。',
    ahaBriefTitle: '使用 AhaCreator brief 模版',
    ahaBriefDescription:
      '我们会预填平台规则；您补充核心信息、创意方向、参考内容等。',
  },

  /** V4 — Brief 达人 — 自有简报（列表行） */
  v4BriefInfluencerOwnBrief: {
    appliesToLabel: '请输入该brief适用达人类型',
    appliesToPlaceholder: '例如：各类意见领袖、人工智能工具评测者、时尚领域意见领袖',
    appliesToRequired: '请填写该简报版本适用的对象或人群',
    addBriefDocumentLabel: '添加 brief 文档',
    briefDocumentPlaceholder:
      '粘贴达人简报链接（如 Google 文档、Notion、飞书等），或上传文件',
    briefDocumentRequired: '请输入简报链接或上传文件',
    briefDocumentInvalidLink: '请输入有效链接',
    uploadBriefDocument: '上传',
    referenceVideosLabel: '参考视频（选填，建议填写）',
    referenceVideosPlaceholder: '逐行粘贴视频链接',
    addVersionButton: '添加版本',
  },

  /** V4 — Brief 达人 — 脚本/创意提交（开拍前对齐） */
  v4BriefInfluencerScriptIdea: {
    sectionTitle: '脚本 / 创意提交',
    sectionDescription:
      '若开启，达人需在正式制作前提交创意或脚本，以便在开拍前对齐内容方向。',
    optionRequireLabel: '需要（制作前先审核）',
    optionSkipLabel: '不需要（达人直接制作内容）',
  },

  /** V4 — Brief 达人 — 交付要求（全平台 / 分平台） */
  v4BriefInfluencerRequirementsForm: {
    perPlatformSectionLabel: '分平台要求',
  },

  // V4 创建活动 — 微调策略 Wishlist
  v4Wishlist: {
    sectionTitle: '意向名单',
    pasteLinksLabel: '粘贴链接',
    orUploadSpreadsheetLabel: '或上传表格',
    wishlistTextPlaceholder:
      '粘贴达人主页链接，多个用逗号或换行分隔',
    spreadsheetDropzoneBeforeXlsx: '将 ',
    spreadsheetDropzoneBetweenExtensions: ' 或 ',
    spreadsheetDropzoneAfterCsv: ' 拖至此处，或点击浏览',
    uploadedFileFallback: '已上传文件',
  },

  // V4 创建活动 — 微调策略 Matching Accuracy（与旧 settings.matchingAccuracy 三档不同，仅 Standard / Broad）
  v4FineTuneMatchingAccuracy: {
    sectionTitle: '匹配精度',
    standardLabel: '标准',
    standardDesc: '适合大多数活动的平衡匹配，兼顾质量与相关性。',
    broadLabel: '扩展',
    broadDesc: '扩大匹配范围以触达更多达人，涵盖更广的达人类型。',
  },

  // V4 创建活动 — 微调策略 筛选问题
  v4FineTuneScreeningQuestions: {
    sectionTitle: '筛选问题',
    sectionDesc:
      '添加达人申请时需回答的问题，以便快速判断谁适合本次活动。',
    questionLabel: '问题 #{number}',
    answerLabel: '回答',
    viewAllAnswers: '查看全部回答',
    questionRequired: '请输入问题',
    questionPlaceholder: '在此输入问题',
    removeQuestion: '删除问题',
    addQuestion: '添加问题',
  },

  // V4 创建活动 — 微调策略 预览匹配卡片
  v4PreviewMatches: {
    whyInfluencerMatchesTitle: '推荐理由',
    notAFit: '不合适',
    saveToInviteList: '发布后邀请',
    savedToInviteList: '已加入邀约名单',
    sampleMatchesTitle: '示例匹配',
    sampleInfluencersBanner:
      '这些是示例匹配，并非您的最终达人名单',
    sampleInfluencersDescription:
      '活动发布后，我们会根据您的策略匹配更多达人并发送邀请。如果示例不合适，请更新左侧策略并刷新预览。',
    allSampleCreatorsReviewed:
      '您已审阅全部示例达人。点击「确认策略并设置预算」继续下一步。',
    noInfluencersMatchTitle: '当前条件下暂无匹配的达人。',
    noInfluencersMatchHint:
      '请放宽筛选范围，以发现更多可能适合您活动的达人。',
    basePlatform: {
      youtube: 'YouTube',
      instagram: 'Instagram',
      tiktok: 'TikTok',
      twitter: 'Twitter',
      x: 'X',
      linkedin: 'LinkedIn',
    },
  },

  v4SavedForLaunch: {
    emptyStatePrefix: '尚未保存达人。前往 ',
    previewMatchesTab: '预览匹配',
    emptyStateSuffix:
      '，保存与活动契合的达人，发布后将显示在此处，便于后续发出邀请。',
    savedForLaunchTab: '待发邀约',
    savedForLaunchTabTooltip: '已加入邀约名单，发布后将优先发出邀请。',
  },

  v4FineTuneStrategy: {
    sectionTitle: '达人匹配策略',
    sectionDescription: '应用您的更改，以刷新右侧显示的示例匹配。',
    matchingLoadingTitle:
      '正在根据达人画像匹配达人，大约需要4分钟。',
    confirmStrategySetBudget: '下一步',
    updateMatches: '应用更改并刷新示例',
    generatingNewSamples: '正在生成新的示例…',
  },

  v4FineTuneRematch: {
    title: '您已在左侧更新了策略。',
    description:
      '是否根据最新策略重新匹配示例达人，以确保发布时的推荐与当前设置一致？',
    rematchCta: '重新匹配',
    keepCta: '保留',
  },

  v4FineTuneRightPanel: {
    keyMetricsTitle: '关键指标（近 20 条帖子）',
    influencerRate: '达人报价',
    historicalRateRange: '历史报价',
    historicalRateRangeTooltip:
      '该达人在 AhaCreator 已完成合作的真实报价，展示为近期合作中的最低–最高区间。',
    estimatedRateRange: '预估报价',
    estimatedRateRangeTooltip:
      '暂无合作记录。基于相似达人的近期合作估算，综合考虑受众、领域、频道表现（如平均播放量、粉丝数）以及该达人与您品牌的匹配度。',
    followers: '粉丝数',
    medianViews: '播放量中位数',
    engagementRate: '互动率',
    cpm: 'CPM',
    cpc: 'CPC',
    deliveryRecordTitle: '履约记录',
    completed: '已完成',
    completionRate: '履约率',
    averageDeliveryDays: '平均履约天数',
    audienceDemographicsTitle: '受众画像',
    verifiedData: '已验证数据',
    targetedRegions: '定向地区',
    age: '年龄',
    gender: '性别',
    influencerInformationTitle: '达人信息',
    aiInferredBadge: 'AI 推断',
    influencerProfilesLabel: '达人画像',
  },

  v4FineTuneInfluencerInfo: {
    rows: {
      ageRange: '达人年纪',
      gender: '性别',
      primaryLanguages: '主要语言',
      languagesFluency: '语言流利度',
      otherLanguages: '其他语言',
      ethnicity: '族裔',
      facePresentation: '出镜形式',
      showsFace: '是否露脸',
      voiceover: '画外音',
      accent: '口音',
    },
    values: {
      female: '女性',
      yes: '是',
      no: '否',
      native: '母语',
      dash: '-',
      accentDemo:
        "清晰、标准的澳大利亚口音，带有典型 Z 世代语气和俚语（如 “it's giving”“tea” 等）。",
    },
  },

  v4FineTuneOnboarding: {
    step1Title: '用示例匹配微调达人策略',
    step1Description:
      '在左侧调整策略，在中间预览匹配达人，在右侧查看详情。',
    step2Title: '任意模块都可微调',
    step2Description:
      '在左侧调整画像、定向或高级筛选；每次修改都会重塑右侧的示例匹配。',
    step3Title: '与策略匹配的示例达人',
    step3Description:
      '将合适的达人加入邀约名单，发布后将自动邀请。其余可标记为「不合适」。此处仅为示例，正式发布后 AhaCreator 会匹配更多达人。',
    step4Title: '结合完整数据做决策',
    step4Description:
      '点击任意示例达人可查看指标、受众与过往品牌合作，据此保存合适人选或放心跳过。',
    totalStepsHint: '共 4 步',
    previous: '上一步',
    done: '完成',
  },

  v4StepsHeader: {
    buildCampaign: '创建活动',
    fineTuneStrategy: '优化达人策略',
    setContentGuidelines: '设置内容规范',
    setBudgetLaunch: '设置预算并发布',
  },

  v4SetBudgetAndLaunch: {
    pageTitle: '设置条款、预算并发布',
    launchCampaign: '发布活动',
    budgetSectionTitle: '活动预算',
    totalCampaignBudgetLabel: '活动总预算',
    usageRightsSectionTitle: '使用权（影响报价）',
    usageRightsSectionDescription:
      '使用权约定您可在多久、以何种方式使用达人内容（广告、转发、长期素材等）。权限越多价值越高，通常对应更高报价。请按活动需要选择。',
    usageRightsOptions: {
      none: '无',
      days7: '7 天',
      days14: '14 天',
      days30: '30 天',
      days60: '60 天',
      days90: '90 天',
      months6: '6 个月',
      year1: '1 年',
      no: '否',
      yes: '是',
    },
    usageRights: {
      linkInBioDuration: {
        title: '主页链接保留时长',
        description:
          '推广链接在 Instagram 或 TikTok 达人主页简介中保留的时长。',
      },
      adAuthorizationCodeDuration: {
        title: '广告授权码',
        description:
          '通过 Instagram 或 TikTok 授权码，使用达人帖子投放广告的权限。',
      },
      postRetentionDuration: {
        title: '帖子保留',
        description: '达人承诺将合作帖子在个人主页保留的时长。',
      },
      contentRepurposeRightsDuration: {
        title: '内容二次使用权',
        description:
          '在原始帖子之外再使用达人内容的权限（例如转发、剪辑、投放广告等）。',
      },
      exclusivityDuration: {
        title: '排他/竞品限制',
        description:
          '在约定期内，达人同意不推广竞争品牌或约定类目。',
        subTitle: '填写品类或竞品',
        placeholder: '例如：Nike、Adidas、运动鞋类',
        requiredMessage: '请填写品类或竞品',
      },
      collaborativePost: {
        title: 'Instagram 共创帖（Collaborative）',
        description: '达人发布 Reel 并将您的品牌添加为共创协作者。',
        subTitle: '品牌 Instagram 账号链接',
        placeholder: '例如：https://www.instagram.com/_ahacreator',
        requiredMessage: '请填写品牌 Instagram 账号链接',
      },
    },
  },

  // V4 创建活动 — 选择内容类型（副标题无合适旧 key，主标题复用 settings.chooseSocialPlatforms）
  v4ChooseContentType: {
    subtitle: '可同时选择多个平台。',
  },

  // V4 创建活动 — 选择国家/地区（占位符复用 bookDemo.placeholders.country）
  v4ChooseCountries: {
    title: '您要面向哪些国家/市场？',
    searchPlaceholder: '搜索国家/地区',
    selectedCountriesTitle: '已选国家/地区（{count}）',
    clearAll: '全部清除',
    moreSelectedCount: '+ {count} ...',
    quickSelectionsTitle: '快捷选择',
    byRegionTitle: '按地区',
  },

  // V4 创建活动 — 浏览量要求
  v4ViewCountRequirement: {
    title: '对达人的中位数浏览量有要求吗？',
    subtitle:
      '以下是我们为保证达人质量设置的最低阈值。若需更严格的标准，可自行调整。',
  },

  // V4 创建活动 — 设置画像输入（Settings Profiles）
  v4SettingsProfiles: {
    title: '为活动生成匹配的达人画像',
    subtitle:
      '可粘贴参考达人、对标产品链接，或用文字描述理想达人，我们将据此生成匹配画像。',
    generateProfile: '生成画像',
    productUrlLabel: '品牌或产品链接',
    productUrlPlaceholder: '填写品牌链接以推广品牌，或填写单个产品链接以推广该产品。',
    productDescriptionLabel: '产品描述',
    productDescriptionPlaceholder:
      '请描述您的产品：它是什么、有什么作用，以及它的独特之处。关键功能、核心卖点和目标用户都有助于提高匹配精准度。',
    productUrlMustBeValidLink: '请输入有效链接',
    atLeastOneInputRequired: '请至少填写一项内容',
    productUrlChangedPrompt:
      '链接已变更。是否刷新产品描述与对标产品以匹配新链接？',
    productDescriptionChangedPrompt:
      '产品描述已变更。是否刷新对标产品建议以匹配更新后的信息？已添加的对标产品不会被移除。',
    refreshSuggestNotNow: '暂不',
    refreshSuggestRefresh: '刷新',
    matchedFromPrefix: '匹配自',
    productUrlOrDescriptionLabel: '产品链接 / 产品描述',
    productUrlOrDescriptionPlaceholder:
      '建议填写，有助于提升匹配度；若不便展示产品信息可留空。',
    referenceCreatorProfileLinksLabel: '参考达人主页链接（选填）',
    referenceCreatorProfileLinksPlaceholder:
      '粘贴 Instagram、TikTok 或 YouTube 个人主页链接',
    referenceCreatorProfileLinksHelp: '用逗号或换行符分隔多个链接。',
    benchmarkProductWebsitesLabel: '对标产品（选填）',
    benchmarkProductWebsitesPlaceholder: '粘贴产品页 URL…',
    benchmarkProductWebsitesHelp:
      '我们将用这些产品构建理想达人画像，并寻找已与这些产品合作过的达人。',
    benchmarkRecommendedTitle: '✦ 来自对标产品的推荐',
    benchmarkAddAll: '全部添加',
    idealCreatorDescriptionLabel: '描述你心目中的达人（选填）',
    idealCreatorDescriptionPlaceholder:
      '简要描述你想要的达人——垂类、受众、地区、内容风格……',
    benchmarkTagsMustBeValidLink:
      '每个标签都必须是有效链接。以下链接无效：{invalidTags}',
  },

  // V4 创建活动 — 画像卡片（Select Profiles 列表项）
  v4ProfilesCard: {
    discard: '移除',
    addToProfiles: '加入画像',
    confirmToAdd: '确认添加',
    profileNameLabel: '达人画像名称',
    profileNamePlaceholder: '例如：AI 工具测评达人、时尚博主',
    descriptionLabel: '描述',
    descriptionPlaceholder: '请详细描述该达人画像',
  },

  // V4 创建活动 — 画像标题变更 / 重新生成描述状态条
  v4ProfilesTitleStatus: {
    titleChangedPrompt:
      '标题已修改。是否让 AhaCreator 重新生成与之匹配的描述？',
    keepCurrent: '保留当前',
    regenerate: '重新生成',
    regeneratingDescription: '正在重新生成达人画像描述…',
    detailsUpdated: '已更新详情',
  },

  // V4 创建活动 — 选择画像（Select Profiles）
  v4SelectProfiles: {
    title: '挑选适合您活动的达人画像',
    subtitle:
      '我们已根据您的输入生成若干选项，请保留喜欢的并丢弃其余项。',
    generatedProfilesTitle: '已生成的画像',
    generatedProfilesSubtitle: '将符合您活动的画像加入右侧。',
    addAll: '全部添加（{count}）',
    addInfluencerProfiles: '添加达人画像',
    allProfilesReviewed: '您已完成所有画像的审阅。',
    matchingLoadingTitle:
      '正在根据您的输入匹配达人画像，请稍后。大约需要 2 分钟。',
    selectedProfilesTitle: '已选画像',
    selectedProfilesSubtitle: 'Aha 将据此为您匹配达人。',
    emptySelectedHint:
      '在任意已生成画像上点击「加入画像」，即可加入此处。AI 将据此匹配真实达人。',
    startMatchingSamples: '开始匹配样本',
    profilesGeneratedFlash: '画像已生成',
    /** 微调策略 — 紧凑卡片 + 全屏编辑弹窗 */
    fineTuneSectionTitle: '达人画像',
    aiGeneratedBadge: 'AI 生成',
    fineTuneEditModalSubtitle:
      '请用自然语言描述您心目中的达人；也可在下方根据产品信息、参考达人或对标产品生成画像。',
    goToEditProfiles: '去编辑画像',
  },

  // V4 创建活动 — Select Profiles 左侧表单区（ProfilesMain）
  v4ProfilesMain: {
    describeCreatorTitle: '描述你心目中的达人',
    describeCreatorSubtitle: '信息越具体，匹配越准确。',
    regenerateModalTitle: '是否保留当前已生成的画像？',
    regenerateModalContent:
      '我们将根据您更新后的输入重新生成画像。是否保留下方已展示的画像？',
    regenerateModalOk: '保留',
    regenerateModalCancel: '不保留',
  },

  v4BriefInfluencerBriefHighlight: {
    title: 'Brief 重点',
    optionalTitle: 'Brief 重点（选填）',
    placeholder: '请输入 Brief 重点',
    description:
      '完整 Brief 可以较长，请在此列出必须了解的要点。达人会优先看到这些重点，确保关键信息不被遗漏。',
  },
};
